module.exports = __webpack_public_path__ + "55ed3b49cb1632430175d694bbd6c300.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Pachantiew/mobile.jpg
// module id = 1376
// module chunks = 47